<script setup lang="ts">
import { useHead } from '@unhead/vue'
const { t } = useI18n()

useHead({
  link: [{
    rel: 'canonical',
    href: `${import.meta.env.VITE_MONOLITH_URL}/about-us`,
  }],
})

useSeoMeta({
  title: t('about.meta.title'),
  description: t('about.meta.description'),
  ogTitle: t('about.meta.title'),
  ogDescription: t('about.meta.description'),
  ogImage: `${S3_ASSETS_URL}/meta-default.jpg`,
})
</script>

<template>
  <div>
    <LayoutNavbar />

    <div class="mb-8 lg:mb-16">
      <div class="w-full bg-white pt-8 md:bg-[#f8f8f0]">
        <h1
          class="mx-auto hidden max-w-screen-md text-balance text-center text-2xl !leading-tight md:block md:text-4xl"
        >
          {{ t('about.section.text_testimonials.title') }}
        </h1>

        <AboutCarousel />
      </div>

      <AboutContent />
    </div>

    <LayoutFooter />
  </div>
</template>
